import React, { useState } from "react";
import PropTypes from "prop-types";
import { Button, Card, CardBody, Col } from "reactstrap";
import LenderModal from "components/modals/LenderModal";
import AppTrackerDealData from "../../features/deal/components/AppTrackerDealData";

/**
 * AppTracker component handles the display and submission of UACC applications.
 *
 * @component
 * @param {number} dealID - The ID of the current deal.
 * @returns {JSX.Element} The rendered component.
 */
const AppTracker = ({ dealID, onAppSubmit }) => {
	// Modal toggles
	const [toggleApplication, setToggleApplication] = useState(false);
	const [isAppSubmitted, setIsAppSubmitted] = useState(false);

	// Toggles the application modal open or close
	const toggleApplicationModal = () => setToggleApplication(!toggleApplication);

	// Button to open the application modal
	const applicationButton = (resubmit = false) => (
		<Button
			size="md"
			className="w-100 btn-primary"
			onClick={toggleApplicationModal}
		>
			{resubmit ? "Resubmit" : "Send App"}
		</Button>
	);

	return (
		<Card>
			<CardBody>
				<h3
					className="text-center"
					style={{
						height: "92px",
						alignItems: "center",
						justifyContent: "center",
						display: "flex",
					}}
				>
					AppTracker Lender
				</h3>
				<Col>
					{!isAppSubmitted ? (
						<LenderModal
							ButtonComponent={applicationButton}
							modalSize="xl"
							modalTitle="App Tracker Application"
							toggle={toggleApplication}
							toggleModal={toggleApplicationModal}
						>
							<AppTrackerDealData
								onAppSubmit={() => {
									onAppSubmit(); // notify parent
									setToggleApplication(false); // close modal
								}}
							/>
						</LenderModal>
					) : (
						<div className="d-flex justify-content-space-between">
							<LenderModal
								ButtonComponent={() => applicationButton(true)}
								modalSize="xl"
								modalTitle="App Tracker Application"
								toggle={toggleApplication}
								toggleModal={toggleApplicationModal}
							>
								<AppTrackerDealData onAppSubmit={onAppSubmit} />
							</LenderModal>
						</div>
					)}
				</Col>
			</CardBody>
		</Card>
	);
};

AppTracker.propTypes = {
	dealID: PropTypes.number.isRequired,
	onAppSubmit: PropTypes.func.isRequired,
};

export default AppTracker;
